/* eslint-disable no-restricted-imports */
import { FC } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import PlaylistGames from '~/client/components/Game/GameView/GameViewDesktop/shared/PlaylistGames';
// import ThemeBadges from '~/client/components/Game/GameView/GameViewMobile/ThemeBadges';
import MoreByProvider from '~/client/components/Game/GameView/GameViewMobile/MoreByProvider';
import MobileClappsToggle from '~/client/components/Game/GameView/shared/ClappsToggle/MobileClappsToggle';
import GameDescription from '~/client/components/Game/GameView/shared/GameDescription';
import CasinoBoost from '~/client/features/CasinoBoost';
import LazyLoad from '~/client/shared/LazyLoad';
import useGameCurrencySelect from '../../GameCurrencySelect/useGameCurrencySelect';
import GameHeader from '../GameHeader';
import useChangeCurrencyNotification from '../hooks/useChangeCurrencyNotification';
import useWalletCurrency from '../hooks/useWalletCurrency';
import MobileGameDetailsTable from '../MobileGameDetailsTable';
import PlayButtons from '../PlayButtons';
import { CashierCurrencyType } from '@/graphql/schema';
import MobileGamePageNavBar from '@/server/components/Game/MobileGameView/MobileGamePageNavBar';
import Header from '@/server/components/Header';

type Props = {
  inGameCurrencyList: string[];
  inGameCurrency?: Unit;
  cashierCurrencyType?: CashierCurrencyType;
  cashierCurrency?: CashierCurrency;
  isLoggedIn: boolean;
  translations: Record<string, string>;
  isUbtcEnabled: boolean;
  rewardsNotification: RewardsNotification;
  isBitcasino?: boolean;
};

const MobileGameModules: FC<Props> = ({
  inGameCurrencyList,
  inGameCurrency,
  cashierCurrencyType,
  cashierCurrency,
  isLoggedIn,
  translations,
  isUbtcEnabled,
  rewardsNotification,
  isBitcasino,
}) => {
  const { game } = useGameContext();
  const { walletCurrency, walletCurrencyType } = useWalletCurrency(
    cashierCurrency,
    cashierCurrencyType,
  );
  const gameCurrencySelect = useGameCurrencySelect(
    isUbtcEnabled,
    inGameCurrencyList,
    inGameCurrency,
    walletCurrency,
  );
  useChangeCurrencyNotification(
    rewardsNotification,
    gameCurrencySelect.selectedCurrency,
    walletCurrency,
  );

  const titleFont = isBitcasino ? 'text-moon-16 font-dm-sans font-medium' : '';

  return (
    <div>
      <Header className="h-14 px-3 -mx-4">
        <MobileGamePageNavBar
          gameCurrencySelect={gameCurrencySelect}
          translations={translations}
        />
      </Header>
      <div className="grid grid-cols-minmax gap-4">
        <GameHeader />
        <PlayButtons
          gameCurrencySelect={gameCurrencySelect}
          cashierCurrencyType={walletCurrencyType}
          cashierCurrency={walletCurrency}
          isLoggedIn={isLoggedIn}
          translations={translations}
        />
        <CasinoBoost module="game" />
        <MobileGameDetailsTable game={game} />
        {/* <ThemeBadges /> */}
        <MobileClappsToggle />
        <GameDescription />
        <LazyLoad>
          <MoreByProvider titleFont={titleFont} />
          <PlaylistGames titleFont={titleFont} />
        </LazyLoad>
      </div>
    </div>
  );
};

export default MobileGameModules;
